import type { FunctionComponent, HTMLAttributes } from "react";

import { Container } from "./styles";

export type Props = {
  isExpand: boolean;
  toggleMessage: {
    after: string;
    before: string;
  };
} & HTMLAttributes<HTMLDivElement>;

export const SearchResultListToggle: FunctionComponent<Props> = ({
  isExpand,
  toggleMessage,
  ...props
}) => (
  <Container $isExpand={isExpand} {...props}>
    {isExpand ? toggleMessage.after : toggleMessage.before}
  </Container>
);

SearchResultListToggle.displayName = "SearchResultListToggle";
